import { TextFieldProps } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { FieldProps, getIn, useFormikContext } from "formik";
import React from "react";

interface Props {
  handleChange?: (value: string) => void;
  disablePast?: boolean;
  disabled?: boolean;
}

const FormikDateTimePicker: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  const {
    handleChange: onDateTimeSelected,
    disablePast,
    disabled,
    error,
    form,
    field,
    required,
    ...rest
  } = props;

  const { setFieldValue } = useFormikContext();
  const isTouched = getIn(form.touched, field.name);
  const errorMessage = getIn(form.errors, field.name);

  const handleChange = (value: any) => {
    setFieldValue(field.name, value);
    onDateTimeSelected?.(value);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        label={props.label}
        value={field.value}
        disablePast={disablePast}
        disableOpenPicker={disabled}
        disabled={disabled}
        onChange={handleChange}
        slotProps={{
          textField: {
            ...rest,
            fullWidth: true,
            error: error ?? Boolean(isTouched && errorMessage),
            required: required,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default FormikDateTimePicker;
